import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * A custom element that displays product spec details.
 * Listens for variant updates and morphs in the server-rendered details for the selected variant.
 *
 * @extends {Component}
 */
class ProductDetailsComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], .shopify-section');
    if (!target) return;
    target.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], .shopify-section');
    if (!target) return;
    target.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event by morphing details from the fetched section HTML.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const productId = this.dataset.productId;
        const newDetails = html.querySelector(`product-details-component[data-product-id="${productId}"]`);
        if (!newDetails) return;

        morph(this, newDetails, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-details] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-details-component')) {
  customElements.define('product-details-component', ProductDetailsComponent);
}
